/**
 * InfoList 정보 목록
 * cjfw-fsmns-mo-pub
 *
 * @author 김정웅
 */
import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

import Text from "components/elements/Text"
// css
import "assets/style/elements/basic-list.scss";

function Element({ children, type, className, data = [] }) {
  console.log('text props', children)

  return (
    <>
      <ul className="basic-list">
        {data.map((item) => (
          // type 1
          <li key={item.id}>
            <span className="title f-medium">{item.title}</span>

            <div className="info-area mt8">
              <Text className="f-green">상품</Text>
              <Text>2023.03.01 ~ 2023.03.03</Text>
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}

export default Element
